// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1178":"d1443463","9806":"e4ad54d5"}[chunkId] + ".chunk.css";
};